<script setup>

	const { locale } = useI18n()
	const url = useRequestURL()

	const { data: pageInit } = await useAPIFetch('InfluencerMarketing')
	const pageText = pageInit.value.body.find(item => item.component === 'Text')
	const list = pageInit.value.body.find(item => item.component === 'List')

	const componentId = ref(list.id)
	const isLoading = ref(false)
	const limit = ref(list.params.limit || 12)

	const { data: page } = await useAPIFetch(`InfluencerMarketing/component/${componentId.value}`, {
		query: {'limit': limit.value}
	})

	const cursor = ref(page.value.cursor)
	let items = ref(page.value.items)

	const loadMore = async () => {
		updateList(true)
	}

	const updateList = async (loadMore = false) => {
		isLoading.value = true

		const result = await useUIFetch(locale.value, `InfluencerMarketing/component/${componentId.value}`, {
			'cursor': loadMore ? cursor.value : null,
			'limit': limit.value,
		})
		if (loadMore) {
			items.value = [...items.value, ...result.items]
		} else {
			items.value = [...result.items]
		}
		cursor.value = result.cursor
		isLoading.value = false
	}

	useHead({
		bodyAttrs: {
			class: 'has-sizer'
		}
	})

	useHeadData({
		title: pageInit.value.meta.title,
		description: pageInit.value.meta.description,
		author: pageInit.value.meta.author,
		copyright: pageInit.value.meta.copyright,
		keywords: pageInit.value.meta.keywords,
		og: pageInit.value.meta.og,
		url: url.href
	})

</script>

<template>
	<div>
		<div class="container">
			<div class="xl:grid grid-cols-12 gap-8">
				<div class="col-span-8">
					<h1 class="text-magenta mb-10">{{ pageInit.attrs.title }}</h1>
					<WysiwygPerex v-if="pageInit.attrs.perex" :value="pageInit.attrs.perex" />
				</div>
			</div>
		</div>
		<Grid v-if="items.length" @loadMore="loadMore" :covers="items" :cursor="cursor?.toString()" :loading="isLoading" />
		<div class="container">
			<div class="xl:grid grid-cols-12 gap-8">
				<div class="col-span-12">
					<WysiwygText v-if="pageText" :value="pageText.content" class="mb-10 xl:mb-20 wysiwyg" />
				</div>
			</div>
		</div>
	</div>
</template>